"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIALOG_USE_CLASSES = exports.MODAL_USE_CLASSES = exports.SIZE_CLASSES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var SIZE_CLASSES = {
  auto: '',
  medium: 'private-modal--medium',
  short: 'private-modal--short',
  tall: 'private-modal--tall'
};
exports.SIZE_CLASSES = SIZE_CLASSES;
var MODAL_USE_CLASSES = {
  default: 'private-modal--default private-modal--is-popup',
  conversational: 'private-modal--conversational private-modal--is-popup',
  info: 'private-modal--info private-modal--is-popup',
  success: 'private-modal--success private-modal--is-popup',
  danger: 'private-modal--danger private-modal--is-popup',
  fullscreen: 'private-modal--fullscreen',
  lightbox: 'private-modal--lightbox',
  upgrades: 'private-modal--upgrades private-modal--is-popup'
};
exports.MODAL_USE_CLASSES = MODAL_USE_CLASSES;
var DIALOG_USE_CLASSES = (0, _extends2.default)({}, MODAL_USE_CLASSES, {
  sidebar: 'private-modal--sidebar'
});
exports.DIALOG_USE_CLASSES = DIALOG_USE_CLASSES;